module.exports = __webpack_public_path__ + "media/images/gallery/snr_off-0f188e85c10544fdd3978242a91550e7.gif";